module.exports = __webpack_public_path__ + "static/media/default.d6098865.png";